"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "+1 24579 54581" | "info@example.com" */
    link0Text: ReactNode;
    /** Detected variants: "tel:+12456589856" | "mailto:info@example.com" */
    href: string;
};

type FooterSectionUls3Item = {
    key: Key | null | undefined;
    /** Detected variants: "Terms & Condition" | "Privacy Policy" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.termsAndCondition" | "all_routes.privacyPolicy" */
    href: string;
};

type FooterSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "facebook" | "twitter" | "instagram" | "linkedin" */
    ariaLabel: string;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Home" | "About Us" | "Specialities" | "Doctors" | "Contact Us" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.home" | "all_routes.aboutUs" | "all_routes.speciality" | "all_routes.doctorProfile1" | "all_routes.contactUs" */
    href: string;
};
export type HomeFourteenFooterSectionGeneratedProps = {
    /** Default: "DOCCURE" */
    footerDiv0Div0DivText?: ReactNode;
    footerDiv1Div0Div0ClassName?: string;
    /** Default: "Quick Links" */
    footerDiv1Div0Div0Div0Div0H30H3Text?: ReactNode;
    footerDiv1Div0Div0Div0Div0H30H3Visible?: boolean;
    footerDiv1Div0Div0Div0Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Div0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Call / Email" */
    footerDiv1Div0Div0Div1Div0Div0H40H4Text?: ReactNode;
    footerDiv1Div0Div0Div1Div0Div0H40H4Visible?: boolean;
    footerDiv1Div0Div0Div1Div0Div0H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Div0Div1Div0Div0H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "Our Address" */
    footerDiv1Div0Div0Div1Div0Div1H40H4Text?: ReactNode;
    footerDiv1Div0Div0Div1Div0Div1H40H4Visible?: boolean;
    footerDiv1Div0Div0Div1Div0Div1H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Div0Div1Div0Div1H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "8432 Mante Highway, Aminaport, USA, IC410" */
    footerDiv1Div0Div0Div1Div0Div1P0PText?: ReactNode;
    /** Default: "Contact" */
    footerDiv1Div0Div0Div1Div0H30H3Text?: ReactNode;
    footerDiv1Div0Div0Div1Div0H30H3Visible?: boolean;
    footerDiv1Div0Div0Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Div0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    footerDiv1Div0Div0Div2Div0Div0Form0FormVisible?: boolean;
    footerDiv1Div0Div0Div2Div0Div0Form0FormRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Div0Div2Div0Div0Form0FormProps?: Partial<ComponentProps<"form">>;
    /** Default: "search" */
    footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonAriaLabel?: string;
    footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonVisible?: boolean;
    footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Enter Email Address" */
    footerDiv1Div0Div0Div2Div0Div0Form0Input0InputPlaceholder?: string;
    /** Default: "Join our Community" */
    footerDiv1Div0Div0Div2Div0H40H4Text?: ReactNode;
    footerDiv1Div0Div0Div2Div0H40H4Visible?: boolean;
    footerDiv1Div0Div0Div2Div0H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Div0Div0Div2Div0H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "Get the latest news, offers, and insights delivered straight to your inbox." */
    footerDiv1Div0Div0Div2Div0P0PText?: ReactNode;
    /** Default: "all_routes.home" */
    footerDiv2Div0Div0Link0LinkHref?: string;
    footerDiv2Div0Div0Link0LinkVisible?: boolean;
    footerDiv2Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv2Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "logo" */
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-white-14.svg" */
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageSrc?: string;
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerDiv2Div0Div1ClassName?: string;
    /** Default: "Copyright © 2026" */
    footerDiv2Div0Div1Div0P0PText?: ReactNode;
    /** Default: ". All Rights Reserved" */
    footerDiv2Div0Div1Div0P0PText2?: ReactNode;
    /** Default: "all_routes.home" */
    footerDiv2Div0Div1Div0P0Link0LinkHref?: string;
    /** Default: "Doccure" */
    footerDiv2Div0Div1Div0P0Link0LinkText?: ReactNode;
    footerDiv2Div0Div1Div0P0Link0LinkVisible?: boolean;
    footerDiv2Div0Div1Div0P0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv2Div0Div1Div0P0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "footer" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-15.png" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "footer" */
    footerImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-16.png" */
    footerImageWithBasePath1ImageSrc?: string;
    footerImageWithBasePath1ImageVisible?: boolean;
    footerImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerSectionUls2LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls3LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    pLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionDivs: FooterSectionDivsItem[];
    footerSectionUls3: FooterSectionUls3Item[];
    footerSectionUls2: FooterSectionUls2Item[];
    footerSectionUls: FooterSectionUlsItem[];
    footerSectionDivsItemWrapper?: (item: FooterSectionDivsItem, content: ReactNode) => ReactNode;
    footerSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkVisible?: boolean;
    footerSectionDivsLinkRenderer?: (item: FooterSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls3ItemWrapper?: (item: FooterSectionUls3Item, content: ReactNode) => ReactNode;
    footerSectionUls3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls3LinkVisible?: boolean;
    footerSectionUls3LinkRenderer?: (item: FooterSectionUls3Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls3LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls2ItemWrapper?: (item: FooterSectionUls2Item, content: ReactNode) => ReactNode;
    footerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkVisible?: boolean;
    footerSectionUls2LinkRenderer?: (item: FooterSectionUls2Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeFourteenFooterSectionGenerated: FC<HomeFourteenFooterSectionGeneratedProps> = ({
    footerDiv0Div0DivText = "DOCCURE",
    footerDiv1Div0Div0Div0Div0H30H3Text = "Quick Links",
    footerDiv1Div0Div0Div0Div0H30H3Visible,
    footerDiv1Div0Div0Div0Div0H30H3Renderer,
    footerDiv1Div0Div0Div0Div0H30H3Props,
    footerDiv1Div0Div0Div1Div0Div0H40H4Text = "Call / Email",
    footerDiv1Div0Div0Div1Div0Div0H40H4Visible,
    footerDiv1Div0Div0Div1Div0Div0H40H4Renderer,
    footerDiv1Div0Div0Div1Div0Div0H40H4Props,
    footerDiv1Div0Div0Div1Div0Div1H40H4Text = "Our Address",
    footerDiv1Div0Div0Div1Div0Div1H40H4Visible,
    footerDiv1Div0Div0Div1Div0Div1H40H4Renderer,
    footerDiv1Div0Div0Div1Div0Div1H40H4Props,
    footerDiv1Div0Div0Div1Div0Div1P0PText = "8432 Mante Highway, Aminaport, USA, IC410",
    footerDiv1Div0Div0Div1Div0H30H3Text = "Contact",
    footerDiv1Div0Div0Div1Div0H30H3Visible,
    footerDiv1Div0Div0Div1Div0H30H3Renderer,
    footerDiv1Div0Div0Div1Div0H30H3Props,
    footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonAriaLabel = "search",
    footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonVisible,
    footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonRenderer,
    footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonProps,
    footerDiv1Div0Div0Div2Div0Div0Form0Input0InputPlaceholder = "Enter Email Address",
    footerDiv1Div0Div0Div2Div0H40H4Text = "Join our Community",
    footerDiv1Div0Div0Div2Div0H40H4Visible,
    footerDiv1Div0Div0Div2Div0H40H4Renderer,
    footerDiv1Div0Div0Div2Div0H40H4Props,
    footerDiv1Div0Div0Div2Div0P0PText = "Get the latest news, offers, and insights delivered straight to your inbox.",
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageAlt = "logo",
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-white-14.svg",
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageVisible,
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageRenderer,
    footerDiv2Div0Div0Link0ImageWithBasePath0ImageProps,
    footerDiv2Div0Div0Link0LinkHref = "all_routes.home",
    footerDiv2Div0Div0Link0LinkVisible,
    footerDiv2Div0Div0Link0LinkRenderer,
    footerDiv2Div0Div0Link0LinkProps,
    footerDiv2Div0Div1Div0P0Link0LinkHref = "all_routes.home",
    footerDiv2Div0Div1Div0P0Link0LinkText = "Doccure",
    footerDiv2Div0Div1Div0P0Link0LinkVisible,
    footerDiv2Div0Div1Div0P0Link0LinkRenderer,
    footerDiv2Div0Div1Div0P0Link0LinkProps,
    footerDiv2Div0Div1Div0P0PText = "Copyright © 2026",
    footerDiv2Div0Div1Div0P0PText2 = ". All Rights Reserved",
    footerImageWithBasePath0ImageAlt = "footer",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-bg-15.png",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    footerImageWithBasePath1ImageAlt = "footer",
    footerImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/footer-bg-16.png",
    footerImageWithBasePath1ImageVisible,
    footerImageWithBasePath1ImageRenderer,
    footerImageWithBasePath1ImageProps,
    footerDiv1Div0Div0Div2Div0Div0Form0FormVisible,
    footerDiv1Div0Div0Div2Div0Div0Form0FormRenderer,
    footerDiv1Div0Div0Div2Div0Div0Form0FormProps,
    footerSectionUls2LiLink0LinkProps,
    footerSectionUls3LiLink0LinkProps,
    liLink0LinkProps,
    pLink0LinkProps,
    footerDiv1Div0Div0ClassName,
    footerDiv2Div0Div1ClassName,
    footerSectionDivs,
    footerSectionUls3,
    footerSectionUls2,
    footerSectionUls,
    footerSectionDivsItemWrapper,
    footerSectionDivsRenderer,
    footerSectionDivsLinkVisible,
    footerSectionDivsLinkRenderer,
    footerSectionDivsLinkProps,
    footerSectionUls3ItemWrapper,
    footerSectionUls3Renderer,
    footerSectionUls3LinkVisible,
    footerSectionUls3LinkRenderer,
    footerSectionUls3LinkProps,
    footerSectionUls2ItemWrapper,
    footerSectionUls2Renderer,
    footerSectionUls2LinkVisible,
    footerSectionUls2LinkRenderer,
    footerSectionUls2LinkProps,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
}) => {
    return (
        <footer className="footer footer-fourteen">
            <div className="container">
                <div className="animated-text">{footerDiv0Div0DivText}</div>
            </div>
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv1Div0Div0ClassName ?? "row g-4"}>
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                            <div className="footer-widget mt-0">
                                {renderNode(footerDiv1Div0Div0Div0Div0H30H3Visible, footerDiv1Div0Div0Div0Div0H30H3Renderer, (
                                    <h3 className="footer-title" {...(footerDiv1Div0Div0Div0Div0H30H3Props ?? {})}>{footerDiv1Div0Div0Div0Div0H30H3Text}</h3>
                                ))}
                                <ul className="footer-menu">
                                    {renderCollectionNode(
                                        footerSectionUls,
                                        (item: FooterSectionUlsItem) => (
                                            <li key={item.key}>
                                                {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                    <SmartLink href={item.href} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </li>
                                        ),
                                        footerSectionUlsItemWrapper,
                                        footerSectionUlsRenderer
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                            <div className="footer-widget">
                                {renderNode(footerDiv1Div0Div0Div1Div0H30H3Visible, footerDiv1Div0Div0Div1Div0H30H3Renderer, (
                                    <h3 className="footer-title" {...(footerDiv1Div0Div0Div1Div0H30H3Props ?? {})}>{footerDiv1Div0Div0Div1Div0H30H3Text}</h3>
                                ))}
                                <div className="footer-contact">
                                    {renderNode(footerDiv1Div0Div0Div1Div0Div0H40H4Visible, footerDiv1Div0Div0Div1Div0Div0H40H4Renderer, (
                                        <h4 {...(footerDiv1Div0Div0Div1Div0Div0H40H4Props ?? {})}>{footerDiv1Div0Div0Div1Div0Div0H40H4Text}</h4>
                                    ))}
                                    {renderCollectionNode(
                                        footerSectionDivs,
                                        (item: FooterSectionDivsItem) => (
                                            <p key={item.key}>
                                                {renderItemNode(footerSectionDivsLinkVisible, footerSectionDivsLinkRenderer, item, (
                                                    <SmartLink href={item.href} {...(typeof footerSectionDivsLinkProps === "function" ? footerSectionDivsLinkProps(item) : (footerSectionDivsLinkProps ?? {}))} {...(typeof pLink0LinkProps === "function" ? pLink0LinkProps(item) : (pLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </p>
                                        ),
                                        footerSectionDivsItemWrapper,
                                        footerSectionDivsRenderer
                                    )}
                                </div>
                                <div className="footer-contact">
                                    {renderNode(footerDiv1Div0Div0Div1Div0Div1H40H4Visible, footerDiv1Div0Div0Div1Div0Div1H40H4Renderer, (
                                        <h4 {...(footerDiv1Div0Div0Div1Div0Div1H40H4Props ?? {})}>{footerDiv1Div0Div0Div1Div0Div1H40H4Text}</h4>
                                    ))}
                                    <p>{footerDiv1Div0Div0Div1Div0Div1P0PText}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 offset-xl-2 col-lg-6 col-md-12 col-sm-12">
                            <div className="footer-widget footer-join">
                                {renderNode(footerDiv1Div0Div0Div2Div0H40H4Visible, footerDiv1Div0Div0Div2Div0H40H4Renderer, (
                                    <h4 {...(footerDiv1Div0Div0Div2Div0H40H4Props ?? {})}>{footerDiv1Div0Div0Div2Div0H40H4Text}</h4>
                                ))}
                                <p>{footerDiv1Div0Div0Div2Div0P0PText}</p>
                                <div className="subscribe-input">
                                    {renderNode(footerDiv1Div0Div0Div2Div0Div0Form0FormVisible, footerDiv1Div0Div0Div2Div0Div0Form0FormRenderer, (
                                        <form action="#" {...(footerDiv1Div0Div0Div2Div0Div0Form0FormProps ?? {})}>
                                            <input type="email" className="form-control" placeholder={footerDiv1Div0Div0Div2Div0Div0Form0Input0InputPlaceholder} />
                                            {renderNode(footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonVisible, footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonRenderer, (
                                                <button type="submit" className="btn-icon btn btn-secondary" aria-label={footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonAriaLabel} {...(footerDiv1Div0Div0Div2Div0Div0Form0Button0ButtonProps ?? {})}>
                                                    <i className="isax isax-arrow-right-1" />
                                                </button>
                                            ))}
                                        </form>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="footer-bottom">
                    <div className="footer-links">
                        {renderNode(footerDiv2Div0Div0Link0LinkVisible, footerDiv2Div0Div0Link0LinkRenderer, (
                            <SmartLink href={footerDiv2Div0Div0Link0LinkHref} {...(footerDiv2Div0Div0Link0LinkProps ?? {})}>
                                {renderNode(footerDiv2Div0Div0Link0ImageWithBasePath0ImageVisible, footerDiv2Div0Div0Link0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={footerDiv2Div0Div0Link0ImageWithBasePath0ImageSrc} alt={footerDiv2Div0Div0Link0ImageWithBasePath0ImageAlt} className="img-fluid" {...(footerDiv2Div0Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </SmartLink>
                        ))}
                        <ul className="social-icon">
                            {renderCollectionNode(
                                footerSectionUls2,
                                (item: FooterSectionUls2Item) => (
                                    <li key={item.key}>
                                        {renderItemNode(footerSectionUls2LinkVisible, footerSectionUls2LinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} aria-label={item.ariaLabel} {...(typeof footerSectionUls2LinkProps === "function" ? footerSectionUls2LinkProps(item) : (footerSectionUls2LinkProps ?? {}))} {...(typeof footerSectionUls2LiLink0LinkProps === "function" ? footerSectionUls2LiLink0LinkProps(item) : (footerSectionUls2LiLink0LinkProps ?? {}))}>
                                                <i className={item.className} />
                                            </SmartLink>
                                        ))}
                                    </li>
                                ),
                                footerSectionUls2ItemWrapper,
                                footerSectionUls2Renderer
                            )}
                        </ul>
                    </div>
                    <div className={footerDiv2Div0Div1ClassName ?? "row g-3 align-items-center"}>
                        <div className="col-xl-6 col-md-7">
                            <p>
                                {footerDiv2Div0Div1Div0P0PText}
                                {renderNode(footerDiv2Div0Div1Div0P0Link0LinkVisible, footerDiv2Div0Div1Div0P0Link0LinkRenderer, (
                                    <SmartLink href={footerDiv2Div0Div1Div0P0Link0LinkHref} {...(footerDiv2Div0Div1Div0P0Link0LinkProps ?? {})}>{footerDiv2Div0Div1Div0P0Link0LinkText}</SmartLink>
                                ))}
                                {footerDiv2Div0Div1Div0P0PText2}
                            </p>
                        </div>
                        <div className="col-xl-6 col-md-5">
                            <ul className="policy-links">
                                {renderCollectionNode(
                                    footerSectionUls3,
                                    (item: FooterSectionUls3Item) => (
                                        <li key={item.key}>
                                            {renderItemNode(footerSectionUls3LinkVisible, footerSectionUls3LinkRenderer, item, (
                                                <SmartLink href={item.href} {...(typeof footerSectionUls3LinkProps === "function" ? footerSectionUls3LinkProps(item) : (footerSectionUls3LinkProps ?? {}))} {...(typeof footerSectionUls3LiLink0LinkProps === "function" ? footerSectionUls3LiLink0LinkProps(item) : (footerSectionUls3LiLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                        </li>
                                    ),
                                    footerSectionUls3ItemWrapper,
                                    footerSectionUls3Renderer
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="img-fluid footer-bg" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath1ImageVisible, footerImageWithBasePath1ImageRenderer, (
                <SmartImage src={footerImageWithBasePath1ImageSrc} alt={footerImageWithBasePath1ImageAlt} className="img-fluid footer-bg-02" {...(footerImageWithBasePath1ImageProps ?? {})} />
            ))}
        </footer>
    );
};

export default HomeFourteenFooterSectionGenerated;
